<template>
  <div class="description">
    <p>
      در ادامه، چند تصویر از مارپیچ های کشیده شده توسط افراد مختلف به شما نمایش
      داده می‌شود. لطفاً برای هر تصویر کلاس مناسب را از میان گزینه‌ها انتخاب
      کرده و میزان اطمینان خود از انتخابتان را نیز مشخص کنید .
    </p>
    <p>
      همچنین می توانید نظر خود را در چندین نوبت وارد کرده و نیز امکان تغییر
      گزینه انتخاب شده نیز وجود دارد.
    </p>

    <button @click="submitName">تایید</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
    };
  },
  methods: {
    submitName() {
      this.$router.push("/home");
    },
  },
};
</script>

<style>
.description {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.description > p {
  padding: 5px;
  margin: 5px 0;
  direction: rtl;
  font-size: larger;
}

button {
  padding: 5px 30px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  font-size: larger;

  font-weight: 600;
}
</style>
